import React, { useContext } from "react";
import tw from "twin.macro";

import AppContext from "./AppContext";

import Button from "@components/Button";
import Container from "@components/Container";

const Callout = ({ refNumber, ...rest }) => {
  const buttonStyle = tw`w-[12.3125rem] mt-6 pl-6 pr-0 text-left font-black tracking-[0.01131rem] text-deepViolet01 bg-periwinkle01 hocus:(bg-periwinkle00) active:(bg-magenta text-grey) lg:(mt-[2.62rem])`;
  const divStyle = tw`text-center text-grey py-10 px-7 lg:(py-10)`;
  const h2Style = tw`font-display font-bold text-[2rem] leading-[0.8] uppercase lg:(text-5xl leading-[0.77])`;
  const pStyle = tw`mt-4 lg:(mt-5)`;

  const { setShowSignUpModal } = useContext(AppContext);

  return (
    <section {...rest}>
      <Container>
        <div css={[divStyle, tw`bg-heroGradient`]}>
          <h2 css={[h2Style]}>
            Want to <br tw="sm:hidden" />
            know more?
          </h2>
          <p css={[pStyle]}>
            Request to speak with a <br tw="sm:hidden" />
            XERAVA sales representative <br tw="sm:hidden" />
            or receive information.
          </p>
          <Button
            data-kfs="contact-a-rep-trigger-callout"
            css={[buttonStyle]}
            onClick={() => setShowSignUpModal(true)}
          >
            Contact a Rep
          </Button>
        </div>
        <div
          css={[
            divStyle,
            tw`bg-[linear-gradient(109deg, #1B1232 53.69%, #3B115D 128.6%)] mt-5 lg:(mt-[1.875rem])`,
          ]}
        >
          <h2 css={[h2Style]}>
            Lead the <br tw="sm:hidden" />
            charge
          </h2>
          <p css={[pStyle]}>
            Choose broad-spectrum <br tw="sm:hidden" />
            coverage for a broad range of <br tw="sm:hidden" />
            cIAI patients with XERAVA.<sup>{refNumber}</sup>
          </p>
          <Button
            internal
            to="/access-and-resources#order-xerava"
            css={[buttonStyle, tw`inline-block`]}
          >
            Ordering info
          </Button>
        </div>
      </Container>
    </section>
  );
};
export default Callout;
